import React from 'react';

import { cn } from './utils';
import { Badge } from './badge';

export type IPillStatus = 'ready' | 'warning' | 'inProgress' | 'neutral' | 'thera' | 'dark';

const StatusPill = ({
  className,
  text,
  status = 'ready',
  isRounded = true,
  isBgTransparent = false,
  icon,
}: {
  className?: string;
  text: string;
  status?: IPillStatus;
  isRounded?: boolean;
  isBgTransparent?: boolean;
  icon?: React.ReactNode;
}) => {
  return (
    <Badge
      variant={status}
      className={cn(
        isRounded ? 'rounded-2xl' : 'rounded-md',
        'px-2 py-1 text-xs font-medium',
        isBgTransparent && 'border-neutral-200 bg-transparent',
        icon && 'gap-1',
        className,
      )}
    >
      {icon && icon}
      {text}
    </Badge>
  );
};

export default StatusPill;
